import React from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const CustomDateTimePicker = ({
  name,
  value,
  onChange,
  onBlur,
  placeholder = "Select Date & Time",
  allowClear = true,
  size = "middle",
  disableFuture = false,
  disablePast = false,
  ...props
}) => {
  const disabledDate = (current) => {
    if (!current) return false;

    if (disableFuture && current.isAfter(dayjs(), "day")) return true;
    if (disablePast && current.isBefore(dayjs().startOf("day"))) return true;

    return false;
  };

  return (
    <DatePicker
      showTime={{ format: "hh:mm A", use12Hours: true }}
      format="DD/MM/YYYY hh:mm A"
      value={value}              // ✅ dayjs ONLY
      onChange={(date) => onChange(date)} // ✅ no formatting here
      onBlur={() => onBlur({ target: { name } })}
      name={name}
      style={{ width: "100%" }}
      placeholder={placeholder}
      allowClear={allowClear}
      disabledDate={disabledDate}
      size={size}
      {...props}
    />
  );
};


export default CustomDateTimePicker;
